document.addEventListener('DOMContentLoaded', function () {
  const CE = customElements.get('media-gallery');
  if (!CE) return;
  const proto = CE.prototype;
  const original = proto.setActiveMedia;
  proto.setActiveMedia = function (mediaId, prepend) {
    // On products flagged via data-disable-reorder (see ao-product-media-gallery.liquid,
    // scoped to the with-variant template only), keep the gallery's original order —
    // activate/scroll to the matching image in place, never move it to the front.
    if (this.dataset && this.dataset.disableReorder === 'true') {
      prepend = false;
    }
    try {
      return original.call(this, mediaId, prepend);
    } catch (err) {
      // Fallback safe implementation with guarded DOM access
      try {
        const viewer = this.elements && this.elements.viewer;
        const thumbnails = this.elements && this.elements.thumbnails;
        const activeMedia = viewer && (viewer.querySelector(`[data-media-id="${mediaId}"]`) || viewer.querySelector('[data-media-id]'));
        if (!activeMedia) return;
        viewer.querySelectorAll('[data-media-id]').forEach((el) => el.classList.remove('is-active'));
        activeMedia.classList && activeMedia.classList.add('is-active');

        if (prepend) {
          const parent = activeMedia.parentElement || activeMedia.parentNode;
          if (parent && parent.firstChild !== activeMedia && typeof parent.prepend === 'function') parent.prepend(activeMedia);

          if (thumbnails) {
            const thumb = thumbnails.querySelector(`[data-target="${mediaId}"]`);
            const tparent = thumb && (thumb.parentElement || thumb.parentNode);
            if (tparent && tparent.firstChild !== thumb && typeof tparent.prepend === 'function') tparent.prepend(thumb);
          }

          if (viewer && viewer.slider && typeof viewer.resetPages === 'function') viewer.resetPages();
        }

        if (typeof this.preventStickyHeader === 'function') this.preventStickyHeader();

        setTimeout(() => {
          const sc = activeMedia.parentElement || activeMedia.parentNode;
          if (( !this.mql.matches || thumbnails) && sc && typeof sc.scrollTo === 'function') {
            sc.scrollTo({ left: activeMedia.offsetLeft });
          }
          const rect = activeMedia.getBoundingClientRect();
          if (rect.top <= -0.5) {
            const top = rect.top + window.scrollY;
            window.scrollTo({ top: top, behavior: 'smooth' });
          }
        });

        if (typeof this.playActiveMedia === 'function') this.playActiveMedia(activeMedia);

        if (thumbnails) {
          const activeThumb = thumbnails.querySelector(`[data-target="${mediaId}"]`);
          if (typeof this.setActiveThumbnail === 'function') this.setActiveThumbnail(activeThumb);
          if (typeof this.announceLiveRegion === 'function') this.announceLiveRegion(activeMedia, activeThumb && activeThumb.dataset && activeThumb.dataset.mediaPosition);
        }
      } catch (e) {
        // swallow fallback errors
        console.warn('media-gallery setActiveMedia fallback failed', e);
      }
    }
  };
});
